﻿import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";
import { ComponentLoaderFactory, ModalDirective } from "ngx-bootstrap";
import { CompanyEditService } from "../../../service/api/jubili/company-edit.service";
import { AuthenticationService } from "../../../service/api/auth/auth.service";
import { NgbModal, NgbModalRef } from "../../../../../node_modules/@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "bo-jub-company-edit-modal",
    templateUrl: "./company-edit-modal.component.html",
    styleUrls: ["./company-edit-modal.component.scss"]
})

export class CompanyEditModalComponent {

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
        private AuthService: AuthenticationService,
        private companyEditService: CompanyEditService,
        private modalService: NgbModal
    ) { }

    // @ViewChild("CompanyEditModal") public CompanyEditModal: any;
    @ViewChild("content") content: any;

    ngbModalRef: NgbModalRef;

    companySurrkey: number = 0;
    companyName: string = "";
    companyGrade: string = "";
    // grade company
    gradecompany: number = 0;
    gradestatus: string = "";

     // Display modal
    show(companysurrkey: number, companyname: string, companygrade: string): void {
        // set value
        this.companySurrkey = companysurrkey;
        this.companyName = companyname;
        this.checkcompanygrade(companygrade);
    }

    checkcompanygrade(companygrade: string): void {
        // set company grade 0=active 1=non-active 2=hold 3=terminate
        console.log(companygrade);
        switch (companygrade) {
            case "0":
                this.companyGrade = "Active";
                break;
            case "1":
                this.companyGrade = "Non-Active";
                break;
            case "2":
                this.companyGrade = "Hold";
                break;
            case "3":
                this.companyGrade = "Terminate";
                break;
            default:
                this.companyGrade = "";
        }

        // this.CompanyEditModal.show();
        this.ngbModalRef = this.modalService.open(this.content);
    }

    // Hide modal
    hide(): void {
        // this.CompanyEditModal.hide();
        this.ngbModalRef.close();
    }
    UpdateGrade(): void {
        // this.CompanyEditModal.hide();
        this.companyEditService.updateGradeCompanyBackOffice(this.gradecompany, this.companySurrkey)
        .subscribe(
            Response => {
                const isSuccess = Response;
                if (isSuccess === true) {
                    // this.saveModal.show();
                    const timeout = setTimeout(() => {
                      this.ngbModalRef.close();
                      window.location.reload();
                  }, 1500);
                } else {
                    const timeout = setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                }
            }
        );
       // window.location.reload();
        // this.router.navigate(['/jubili/company']);
    }

    ChangeStatusgrade(value: any): void {
        // console.log(value);

        if (this.gradecompany === 1) { this.gradestatus = "Non-active"; }
        else if (this.gradecompany === 2) { this.gradestatus = "Hold"; }
        else if (this.gradecompany === 3) { this.gradestatus = "Terminate"; }
        else { this.gradestatus = "Active"; }
    }
}
